import type {OptimizelyUserContext} from '@optimizely/optimizely-sdk'
import type {Toggle} from 'types/Toggle'

/**
 * Opticks `toggle` equivalent for environments that cannot use the singleton
 * Note that these decisions are NOT tracked to EVAS
 * @param presetToggles - toggles that were decided by Lambda or forced in the URL
 * @param optimizelyUserContext - optional, an optimizely context for proper experiment decisions
 */
export const createUniversalToggle = (
  presetToggles?: Record<string, string>,
  optimizelyUserContext?: OptimizelyUserContext
): Toggle => {
  const toggle: Toggle = (experimentId, ...variants) => {
    const presetVariation = presetToggles?.[experimentId]
    let variation = presetVariation || 'a'

    if (optimizelyUserContext && !presetVariation) {
      const decision = optimizelyUserContext.decide(experimentId)
      const {variationKey} = decision

      variation =
        variationKey === 'on'
          ? 'b'
          : variationKey === 'off'
            ? 'a'
            : variationKey || 'a'
    }

    // Convert 'a' | 'b' | ... to index
    const variantIndex = variation.charCodeAt(0) - 'a'.charCodeAt(0)
    const result = variants[variantIndex]

    return typeof result === 'function' ? result() : result
  }

  toggle.displayName = 'UniversalToggle'
  return toggle
}
